module.exports = __webpack_public_path__ + "static/img/71.c475131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/71.png
// module id = ICWD
// module chunks = 0